class HttpError extends Error {
  constructor(message) {
    super(message);
    this.name = "HttpError";
    this.message = message;
  }
}

export default HttpError;
